var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from 'lodash';
import { HITLBase } from './HITLBase';
import URI from 'urijs';
export class Migrations extends HITLBase {
    static getListOfMigrations(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const route = this.getBaseUrl(options);
            const params = _.pick(options, ['appVersion']);
            return this.request({
                route,
                params,
            });
        });
    }
    static runAllMigrations(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const route = this.getBaseUrl(options);
            const params = _.omit(options, ['version', 'meta']);
            const data = _.pick(options, ['meta']);
            return this.request({
                route,
                method: 'POST',
                params,
                data,
            });
        });
    }
    static getRunMigrationsStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl({});
            const route = new URI(baseUrl).segment(this.MIGRATIONS_STATUS_URL).href();
            return this.request({
                route,
            });
        });
    }
    static deleteMigrationsTableLock() {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl({});
            const route = new URI(baseUrl).segment(this.MIGRATIONS_LOCK_URL).href();
            return this.request({
                route,
                method: 'DELETE',
            });
        });
    }
    static getMigrationsInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl({});
            const route = new URI(baseUrl).segment(this.MIGRATIONS_INFO_URL).href();
            return this.request({
                route,
            });
        });
    }
    static getTableDefaultRecords(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl({});
            const route = new URI(baseUrl).segment(this.DEFAULT_RECORDS_URL).href();
            const params = _.omit(options, ['version']);
            return this.request({
                route,
                method: 'GET',
                params,
            });
        });
    }
    static createTableDefaultRecords() {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl({});
            const route = new URI(baseUrl).segment(this.DEFAULT_RECORDS_URL).href();
            return this.request({
                route,
                method: 'POST',
            });
        });
    }
    static syncTableDefaultRecords(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl({});
            const route = new URI(baseUrl).segment(this.DEFAULT_RECORDS_URL).href();
            const params = _.omit(options, ['version']);
            return this.request({
                route,
                method: 'PUT',
                params,
            });
        });
    }
}
Migrations.MODULE_URL = 'migrations';
Migrations.DEFAULT_RECORDS_URL = 'default-records';
Migrations.MIGRATIONS_INFO_URL = 'info';
Migrations.MIGRATIONS_LOCK_URL = 'lock';
Migrations.MIGRATIONS_STATUS_URL = 'status';
//# sourceMappingURL=Migrations.js.map